<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="[getSelectedDEV && 'dev-selected-component']">
    <v-alert v-if="schema.renderHtml" :name="schema.model" :id="generateId(schema.model)" v-bind="schema.attributesAlert" :disabled="schema.readonly">
      <div class="text-h6" v-if="schema.attributesAlert.title">
        {{ schema.attributesAlert.title }}
      </div>
      <div v-html="sanitize(dynamicLabel)" />
    </v-alert>
    <v-alert v-else :name="schema.model" :id="generateId(schema.model)" v-bind="schema.attributesAlert" :disabled="schema.readonly">
      <div class="text-h6" v-if="schema.attributesAlert.title">
        {{ schema.attributesAlert.title }}
      </div>
      <div v-for="item in formatValue(value ? value : schema.attributesAlert.label)" :key="item.name"
        style="white-space: pre-wrap;"
      >
        {{item}}
      </div>
    </v-alert>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import componentMixin from '@/mixins/component-mixin';
import { compileDynamicString } from '@/helpers/page';

export default {
  mixins: [abstractField, devComponentMixin, componentMixin],

  methods: {
    sanitize(dirtyHtml) {
      const sanitizedHtml = this.$sanitize(dirtyHtml)

      return sanitizedHtml
    },

    formatValue(value){

      let format = [];

      if(value != undefined && value != null)
      {
        if(value.includes("||"))
        {
         value = value.split("||");
        }
        else
        {
          format.push(value);
          value = format;
        }
      }

      else
      {
        format.push('');
        value = format;
      }

      return value;
    }
  },

  computed: {
    dynamicLabel() {
      return compileDynamicString(
        {
          page: this.formOptions.page,
          mode: this.formOptions.mode,
          originalString: this.value ? this.value : this.schema.attributesAlert.label,
          index: this.formOptions?.index
        }
      );
    },
  }
};
</script>
